import { render, staticRenderFns } from "./PositionDropdown.vue?vue&type=template&id=dbb34be2&"
import script from "./PositionDropdown.vue?vue&type=script&lang=ts&"
export * from "./PositionDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports